/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import { BackgroundColorKey, BorderColorKey, IconColorKey, TextColorKey } from 'theme/types'

import { ButtonColor, ButtonVariant } from './types'

type VariantColorKeys = {
  background?: BackgroundColorKey | 'transparent'
  text: TextColorKey
  icon: IconColorKey
  border?: BorderColorKey
}

type VariantHoverKeys = {
  background?: BackgroundColorKey
  border?: BorderColorKey
  text?: TextColorKey
  icon?: IconColorKey
}

type VariantByColorKeys = Record<ButtonColor, VariantColorKeys>
type VariantByColorHoverKeys = Record<ButtonColor, VariantHoverKeys>

export const variantBaseKeysByColor: Record<ButtonVariant, VariantByColorKeys> = {
  primary: {
    brand: {
      background: 'brandPrimary',
      text: 'inverted',
      icon: 'inverted',
      border: 'brandPrimary',
    },
    neutral: {
      background: 'inverted',
      text: 'inverted',
      icon: 'inverted',
      border: 'inverted',
    },
    danger: {
      background: 'danger',
      text: 'inverted',
      icon: 'inverted',
      border: 'danger',
    },
  },
  secondary: {
    brand: {
      background: 'default',
      text: 'brandPrimary',
      icon: 'brandPrimary',
      border: 'brandPrimary',
    },
    neutral: {
      background: 'default',
      text: 'default',
      icon: 'default',
      border: 'default',
    },
    danger: {
      background: 'default',
      text: 'danger',
      icon: 'danger',
      border: 'danger',
    },
  },
  tertiary: {
    brand: {
      background: 'transparent',
      text: 'brandPrimary',
      icon: 'brandPrimary',
    },
    neutral: {
      background: 'transparent',
      text: 'default',
      icon: 'default',
    },
    danger: {
      background: 'transparent',
      text: 'danger',
      icon: 'danger',
    },
  },
}

export const variantDisabledKeys: Record<ButtonVariant, VariantColorKeys> = {
  primary: {
    background: 'disabled',
    text: 'disabled',
    icon: 'disabled',
    border: 'disabled',
  },
  secondary: {
    background: 'disabled',
    text: 'disabled',
    icon: 'disabled',
    border: 'disabled',
  },
  tertiary: {
    text: 'disabled',
    icon: 'disabled',
  },
}

export const variantHoverKeysByColor: Record<ButtonVariant, VariantByColorHoverKeys> = {
  primary: {
    brand: { background: 'brandPrimaryHover', border: 'brandPrimaryHover' },
    neutral: { background: 'brandPrimaryHover', border: 'brandPrimaryHover' },
    danger: { background: 'dangerHover', border: 'dangerHover' },
  },
  secondary: {
    brand: { text: 'brandPrimaryHover', icon: 'brandPrimaryHover', border: 'brandPrimaryHover' },
    neutral: {
      text: 'brandPrimaryHover',
      icon: 'brandPrimaryHover',
      border: 'brandPrimaryHover',
    },
    danger: { text: 'dangerHover', icon: 'dangerHover', border: 'dangerHover' },
  },
  tertiary: {
    brand: { text: 'brandPrimaryHover', icon: 'brandPrimaryHover' },
    neutral: { text: 'brandPrimaryHover', icon: 'brandPrimaryHover' },
    danger: { text: 'dangerHover', icon: 'dangerHover' },
  },
}
